module.exports = __webpack_public_path__ + "static/img/tractor_256.90a0f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tractor_256.png
// module id = r/0b
// module chunks = 0